// project imports
import { Data } from "iconsax-react";
import { SearchParameterDTO } from "../../../common/types/common.dto.types";
import { ActionResponseType } from "../../../common/types/common.types";
import { ApiClient } from "../../../core/api/apiClient.service";
import { InspectionSetPageInitialState } from "./InspectionSetsPage.types";

// ==============================|| VIEWS - PAGES - INSPECTIONSET - API ||============================== //

// client object for axios calls to backend
const client = new ApiClient();

export const getInspectionSetList = async (
  Params: SearchParameterDTO
): Promise<InspectionSetPageInitialState> => {
  try {
    const URL: string = `InspectionSet/GetInspectionSetList`;
    let data = {} as InspectionSetPageInitialState;
    await client
      .post<ActionResponseType>(URL, Params)
      .then((response: ActionResponseType) => {
        data.Data = response.Data;
      })
      .catch((error) => {
        // console.log(error);
        data = {} as InspectionSetPageInitialState;
      });

    return data;
  } catch (error) {
    // console.log(error);
    throw error;
  }
};
